import {
  account,
  bingoGamesWatcher,
  categoriesController,
  categoryDetailsController,
  depositModal,
  experiment,
  footerWatcher,
  fullScreenManager,
  gameDetailsController,
  globalListeners,
  header,
  headerManager,
  headerProductNavigation,
  hybridApplication,
  idlePopupDisplayController,
  idlePopupFetchingDataController,
  initializing,
  jackpotBetWidgetController,
  jackpotBetWidgetWatcher,
  jackpotDrawerController,
  jackpotsComponentsController,
  jackpotsController,
  launchingGameController,
  launchingRouteDynamicActionController,
  launchingSelfExclusion,
  launchingVideo,
  layoutManager,
  liveGamesContentController,
  loginModal,
  navManager,
  personalizedBannerManager,
  promotionsController,
  recentlyPlayedController,
  registrationModal,
  screenSizeManager,
  searchBarController,
  searchController,
  seoCopyVisibilityController,
  session,
  shuffleGamesController,
  trackingListener,
  watchJackpotsV2,
  watchLivePersonChatAction,
  watchRecentlyPlayed,
  watchSessionToken,
  watchUserAction,
} from './controllers';

const mainConfig = {
  id: 'root',
  context: {
    games: {},
    shuffleGames: {
      status: null,
      availableList: [],
      drawnList: [],
      drawnGame: null,
    },
    strikeGoldData: {
      awardedToday: null,
      awardedEver: null,
    },
    rpVisible: true,
    rpFirstLoad: true,
    basePath: '',
    user: {
      loggedIn: false,
      userCurrency: '',
      userAccountNumber: '',
      userStatus: 'non-customer',
      userToken: '',
    },
    loginModalState: {
      isOpened: false,
      isAwaitingLogin: false,
    },
    gameToLaunch: null,
    isGameModalForMobileOpened: false,
    pendingAccountEvents: [],
    controllersData: {},
    isHybridApplication: false,
    loginCount: 0,
  },
  initial: 'checkingForRedirection',
  states: {
    checkingForRedirection: {
      always: [
        {
          cond: 'shouldRedirectUrl',
          target: 'redirecting',
        },
        {
          target: 'main',
        },
      ],
    },
    redirecting: {
      type: 'atomic',
      invoke: {
        src: 'redirectUrl',
        onDone: {
          target: 'main',
        },
        onError: {
          target: 'main',
        },
      },
    },
    main: {
      type: 'parallel',
      entry: 'setInitialMainConfigValues',
      states: {
        session,
        watchSessionToken,
        watchJackpotsV2,
        watchRecentlyPlayed,
        watchUserAction,
        watchLivePersonChatAction,
        loginModal,
        registrationModal,
        depositModal,
        launchingVideo,
        launchingRouteDynamicActionController,
        launchingGameController,
        launchingSelfExclusion,
        header,
        headerProductNavigation,
        account,
        experiment,
        initializing,
        screenSizeManager,
        fullScreenManager,
        globalListeners,
        trackingListener,
        headerManager,
        navManager,
        layoutManager,
        personalizedBannerManager,
        categoriesController,
        recentlyPlayedController,
        jackpotsComponentsController,
        footerWatcher,
        bingoGamesWatcher,
        shuffleGamesController,
        searchBarController,
        searchController,
        promotionsController,
        gameDetailsController,
        seoCopyVisibilityController,
        idlePopupFetchingDataController,
        idlePopupDisplayController,
        jackpotBetWidgetController,
        jackpotBetWidgetWatcher,
        hybridApplication,
        jackpotsController,
        categoryDetailsController,
        jackpotDrawerController,
        liveGamesContentController,
      },
    },
  },
};

export default mainConfig;
